<div class="modern-form-group" [class.modern-switch-row]="props.layout === 'horizontal'">
  <div class="modern-switch-left" *ngIf="props.layout === 'horizontal'">
    <label class="modern-form-label" *ngIf="props.label">{{ props.label }}</label>
    <small class="form-help" *ngIf="props.description">{{ props.description }}</small>
  </div>
  <ng-container *ngIf="props.layout !== 'horizontal'">
    <label class="modern-form-label" *ngIf="props.label">{{ props.label }}</label>
  </ng-container>
  <div class="switch-container">
    <label class="modern-switch">
      <input
        type="checkbox"
        [formControl]="formControl"
        [formlyAttributes]="field" />
      <span class="slider"></span>
    </label>
    <span class="switch-label">{{ switchLabel }}</span>
  </div>
  <small class="form-help" *ngIf="props.description && props.layout !== 'horizontal'">{{ props.description }}</small>
</div>
